import { useAppStore } from '../stores/app';

export default function useRegistrationUrl() {
  const { config } = useAppStore();

  if (/iphone|ipad|ipod|android|OpenHarmony/i.test(navigator.userAgent)) {
    return config.extInfo.registrationUrlMobile || '';
  }

  return config.extInfo.registrationUrlDesktop || '';
}
